import { MagistralDrugPrescription, Prescription } from '../types';

import { isMagistralDrugMedicinePrescription } from './isMagistralDrugMedicinePrescription';

export const isMagistralDrugPrescription = (prescription: Prescription): prescription is MagistralDrugPrescription => {
   return isMagistralDrugMedicinePrescription(prescription.medicinePrescription);
};
